<template>
	<div class="page-container">
		<!-- MODAL DEPOSITAR VALOR -->
		<div class="modal" v-bind:class="dialogDepositVisible(showDialogDeposit)">
			<div class="modal-background"></div>
			<div class="modal-content">
				<div class="card mx-3">
					<header class="card-header">
						<p class="card-header-title">
							Digite o valor para depósito
						</p>
					</header>
					<div class="card-content">
						<div class="content">
							<div class="notification is-danger" v-if="valorError">
								{{ msgErrorForm }}
							</div>
							<div class="field">
								<label class="label">Valor</label>
								<p class="control has-icons-left has-icons-right">
									<money class="input" v-bind:class="inputError(valorError)" type="text" placeholder="Valor" v-model="valor" v-bind="money" v-on:blur="verifyInputError(valor, 'valor')"></money>
									<span class="icon is-small is-left">
										<i class="fa-solid fa-brazilian-real-sign" v-bind:class="inputError(valorError)"></i>
									</span>
									<span class="icon is-small is-right" v-if="valorError">
										<i class="fa-solid fa-circle-exclamation" v-bind:class="inputError(valorError)"></i>
									</span>
								</p>
							</div>
						</div>
					</div>
					<footer class="modal-card-foot has-background-white	">
						<button v-bind:class="loadingClass()" class="button is-danger" v-on:click="showHideDialogDeposit(false)"><strong>FECHAR</strong></button>
						<button v-bind:class="loadingClass()" class="button is-link" v-on:click="confirmarValorDeposito()"><strong>CONFIRMAR</strong></button>
					</footer>
				</div>
			</div>
			<button class="modal-close is-large" aria-label="close"></button>
		</div>
		<!-- FIM MODAL DEPOSITAR VALOR -->
		<!-- MODAL ALTERAR VALOR RODADA -->
		<div class="modal" v-bind:class="dialogDepositChangeValue(showDialogChangeValue)">
			<div class="modal-background"></div>
			<div class="modal-content">
				<div class="card mx-3">
					<header class="card-header">
						<p class="card-header-title">
							Digite o novo valor para a rodada
						</p>
					</header>
					<div class="card-content">
						<div class="content">
							<div class="notification is-danger" v-if="valorRodadaError">
								{{ msgErrorFormValorRodada }}
							</div>
							<div class="field">
								<p class="control has-icons-left has-icons-right">
									<money class="input" v-bind:class="inputError(valorRodadaError)" type="text" placeholder="Valor" v-model="valorRodada" v-bind="money" v-on:blur="verifyInputError(valor, 'valor')"></money>
									<span class="icon is-small is-left">
										<i class="fa-solid fa-brazilian-real-sign" v-bind:class="inputError(valorRodadaError)"></i>
									</span>
									<span class="icon is-small is-right" v-if="valorRodadaError">
										<i class="fa-solid fa-circle-exclamation" v-bind:class="inputError(valorRodadaError)"></i>
									</span>
								</p>
							</div>
						</div>
					</div>
					<footer class="modal-card-foot has-background-white	">
						<button v-bind:class="loadingClass()" class="button is-link" v-on:click="showHideDialogChangeValue(false)"><strong>OK</strong></button>
					</footer>
				</div>
			</div>
			<button class="modal-close is-large" aria-label="close"></button>
		</div>
		<!-- FIM MODAL ALTERAR VALOR RODADA -->
		<md-dialog-alert
		:md-active.sync="alert"
		:md-content="msgAlert"
		md-confirm-text="Ok" />
		<md-app md-mode="fixed">
			<md-app-toolbar class="md-primary">
				<md-button class="md-icon-button" @click="backHome()">
					<md-icon>arrow_back</md-icon>
				</md-button>
				<span class="md-title" style="font-size: 15px; font-weight: bold;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;max-width: 240px; margin-left: 0;">
					Roleta da Sorte!
				</span>
				<button v-if="loggedIn" class="button is-primary" style="position: absolute;right: 5px;" @click="goToPerfil()"><i class="fa-solid fa-user mr-1"></i> <strong>{{ cliente.name.substring(0, 10) }}</strong></button>
			</md-app-toolbar>
			<md-app-content style="padding: 5px;padding-top: 0px;background-size: contain !important;" class="p-2" :style="{ 'background-image': 'url(' + require('@/assets/seamless-money-background-vector.jpg') + ') !important' }">
				<!-- <div class="roulette_bg" v-if="loggedIn" :style="{ 'background-image': 'url(' + require('@/assets/bg_roulette.gif') + ') !important' }"></div> -->
				<div class="roulette" v-if="loggedIn">
					<div class="spinner"></div>
					<div class="shadow"></div>
					<div class="markers">
						<div class="triangle"></div>
					</div>
					<div class="button" @click="liberarRoleta()" v-bind:class="loadingLiberandoClass()">
						<span v-if="liberado">GIRAR</span>
						<span v-if="!liberado" class="icon"><i class="fa-solid fa-unlock"></i></span>
					</div>
				</div>
				<div class="columns is-centered" v-if="!loggedIn">
					<div class="column is-half">
						<div class="card">
							<div class="card-content">
								<div class="content">
									<blockquote>Caso ainda não possua cadastro, é rápido e fácil. Basta clicar no botão <strong><span class="has-text-link">CADASTRAR</span></strong>.<br>Se ja possuir, basta clicar em <strong><span class="has-text-primary">ENTRAR</span></strong>.</blockquote>
									<div class="buttons">
										<button class="button is-link is-fullwidth" @click="goToClientRegister()">Cadastrar</button>
										<button class="button is-primary is-fullwidth" @click="goToClientLogin()">Entrar</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div style="position: absolute; bottom: 8px; width: 100%;" v-if="loggedIn">
					<div class="columns is-centered">
						<div class="column is-8">
							<div class="card" style="max-width: 96% !important;">
								<div class="card-content">
									<div class="content">
										<nav class="level is-mobile">
											<div class="level-item has-text-centered">
												<div>
													<p class="heading"><strong>Saldo</strong><br><span style="font-size: xx-small;">Clique para depositar</span></p>
													<p class="title"><button class="button is-link is-large btn-balance" @click="showHideDialogDeposit(true)">{{ formataValor(cliente.balance) }}</button></p>
												</div>
											</div>
											<div class="level-item has-text-centered">
												<div>
													<p class="heading"><strong>Valor Rodada</strong><br><span style="font-size: xx-small;">Clique para alterar</span></p>
													<p class="title">
														<button class="button is-link is-large" @click="showHideDialogChangeValue(true)">{{ formataValor(valorRodada) }}</button>
													</p>
												</div>
											</div>
										</nav>
									</div>
									<div class="content" v-if="cliente.balance <= 0">
										<blockquote>
											Seu saldo está zerado. Você pode realizar um depósito clicando no botão abaixo.
										</blockquote>
										<div class="buttons">
											<button class="button is-link is-fullwidth" @click="showHideDialogDeposit(true)">Depositar</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</md-app-content>
		</md-app>
	</div>
</template>
<script>

	import axios from 'axios'
	import $ from 'jquery'
	import Velocity from 'velocity-animate'
	import 'velocity-animate/velocity.ui';
	import { Money } from 'v-money'

	export default {
		name: 'TitanRoulette',
		components: {
			Money
		},
		props: [],
		data () {
			return {
				alert: false,
				msgAlert: '',
				loggedIn: false,
				showDialogDeposit: false,
				showDialogChangeValue: false,
				valorError: null,
				valorRodadaError: null,
				loadingForm: false,
				valorRodada: 1,
				msgErrorForm: '',
				msgErrorFormValorRodada: '',
				liberado: false,
				liberandoRoleta: false,
				roletaBloqueada: false,
				playResult: {},
				money: {
					decimal: ',',
					thousands: '.',
					prefix: 'R$ ',
					precision: 2,
					masked: false
				},
				valor: '',
				data: [
					{ id: '', type: 'sad', color: '#D61C4E', text: '', ikon: 'sentiment_very_dissatisfied' },
					{ id: '', type: 'quiz', color: '#1d61ac', text: '1.5x' },
					{ id: '', type: 'quiz', color: '#D61C4E', text: '0x' },
					{ id: '', type: 'quiz', color: '#E15FED', text: '5x' },
					{ id: '', type: 'sad', color: '#D61C4E', text: '', ikon: 'sentiment_very_dissatisfied' },
					{ id: '', type: 'replay', color: '#881f7e', text: 'PLAY AGAIN', ikon: 'replay' },
					{ id: '', type: 'quiz', color: '#D61C4E', text: '0x' },
					{ id: '', type: 'quiz', color: '#1d61ac', text: '1.5x' },
					{ id: '', type: 'sad', color: '#D61C4E', text: '', ikon: 'sentiment_very_dissatisfied' },
					{ id: '', type: 'quiz', color: '#efe61f', text: '2x' },
					{ id: '', type: 'quiz', color: '#D61C4E', text: '0x' },
					{ id: '', type: 'quiz', color: '#03C988', text: '10x' },
					{ id: '', type: 'replay', color: '#881f7e', text: 'PLAY AGAIN', ikon: 'replay' }
					],
				_bis: false,
				_angle: 0,
				_index: 0,
				options: {
					angleOffset: -90
				}
			}
		},
		created() {
			if (this.$store.state.cliente) {
				this.loggedIn = true
			}
		},
		methods: {
			backHome: function() {
				this.$router.push({ name: 'TitanHome'})
			},
			goToClientLogin: function() {
				this.$router.push({ name: 'TitanClientLogin'})
			},
			goToClientRegister: function() {
				this.$router.push({ name: 'TitanClientRegister' })
			},
			goToPerfil: function() {
				this.$router.push({ name: 'TitanClient' })
			},
			dialogDepositVisible: function(showDialogDeposit) {
				return {
					'is-active': (showDialogDeposit == true)
				}
			},
			dialogDepositChangeValue: function(showDialogChangeValue) {
				return {
					'is-active': (showDialogChangeValue == true)
				}
			},
			showHideDialogDeposit: function(abrir){
				this.showDialogDeposit = abrir;
			},
			showHideDialogChangeValue: function(abrir){
				this.showDialogChangeValue = abrir;
			},
			loadingClass: function() {
				return {
					'is-loading': (this.loadingForm == true)
				}
			},
			loadingLiberandoClass: function() {
				return {
					'is-loading': (this.liberandoRoleta == true)
				}
			},
			inputError: function(campo) {
				return {
					'is-danger has-text-danger': (campo == true),
					'is-primary has-text-primary': (campo == false),
				}
			},
			verifyInputError: function(valor, campo) {
				if (campo == 'valor') {
					if (valor != '') this.valorError = false
						else this.valorError = true
				}

				if (this.valorError)
					this.msgErrorForm = 'Preencha corretamente os campos.';
			},
			formataValor: function(valor) {
				return parseFloat(valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
			},
			render: function() {
				var $spinner = $('.spinner');
				var D = $('.roulette').width();
				var R = D*.5;

				var count = this.data.length;
				var delta = 360/count;

				for(var i=0; i<count; i++){

					var item = this.data[i];

					var color = item.color;
					var text = item.text;
					var ikon = item.ikon;

					var html = [];
					html.push('<div class="item" ');
					html.push('data-index="'+i+'" ');
					html.push('data-type="'+item.type+'" ');
					html.push('>');
					html.push('<span class="label">');
					if(ikon)
						html.push('<i class="material-icons">'+ikon+'</i>');
					html.push('<span class="text">'+text+'</span>');
					html.push('</span>');
					html.push('</div>');

					var $item = $(html.join(''));

				    var borderTopWidth = D + D*0.0025; //0.0025 extra :D
				    var deltaInRadians = delta * Math.PI / 180;
				    var borderRightWidth = D / ( 1/Math.tan(deltaInRadians) );

				    var r = delta*(count-i) + this.options.angleOffset - delta*.5;

				    $item.css({
				    	borderTopWidth: borderTopWidth,
				    	borderRightWidth: borderRightWidth,
				    	transform: 'scale(2) rotate('+ r +'deg)',
				    	borderTopColor: color
				    });

				    var textHeight = parseInt(((2*Math.PI*R)/count)*.5);

				    $item.find('.label').css({
				      //transform: 'translateX('+ (textHeight) +'px) translateY('+  (-1 * R) +'px) rotateZ('+ (90 + delta*.5) +'deg)',
				    	transform: 'translateY('+ (D*-.25) +'px) translateX('+  (textHeight*1.03) +'px) rotateZ('+ (90 + delta*.5) +'deg)',
				    	height: textHeight+'px',
				    	lineHeight: textHeight+'px',
				    	textIndent: (R*.1)+'px'
				    });

				    $spinner.append($item);
				}

				$spinner.css({
					fontSize: parseInt(R*0.06)+'px'
				});
			},
			spin: function(_index) {

				if (this.cliente.balance <= 0 || this.liberandoRoleta) return false;

				var count = this.data.length;
				var delta = 360/count;
				var index = !isNaN(parseInt(_index))? parseInt(_index) : parseInt(Math.random()*count);

				var a = index * delta + ((this._bis)? 1440 : -1440);

				this._bis = !this._bis;
				this._angle = a;
				this._index = index;

				var $spinner = $('.spinner');

				var v = this;
				Velocity($spinner,{
					rotateZ: a +'deg'
				},{
					easing: 'easeOutQuint',
					duration: 5000,
					begin: function() { $('.roulette').addClass('busy') },
					complete: function() {
						$('.roulette').removeClass('busy');

						if (v.playResult.balance > v.$store.state.cliente.balance) {
							Velocity($('.btn-balance'), "callout.shake",{
								easing: 'easeOutQuint',
								duration: 1000
							});
						}

						v.updateClientBalance(v.playResult.balance);
						v.liberado = false;
						v.roletaBloqueada = false;
						v.playResult = {};
					}
				});
			},
			confirmarValorDeposito: function() {
				if (this.cliente) {

					this.loadingForm = true;

					var jsonDeposit = {};
					jsonDeposit.value = this.valor;

					var form = new FormData();
					form.append("data", JSON.stringify(jsonDeposit));

					var config = {
						headers: {'Content-Type': 'application/x-www-form-urlencoded', Authorization: 'Bearer  ' + this.$store.state.cliente.token}
					};

					var v = this;
					axios.post(this.$root.$data.API_URL + 'client/deposit', form, config)
					.then(function (response) {
				        // console.log(response);
						let result = response.data
						if (result.success && result.deposit) {
							v.$router.push({ name: 'TitanClientDeposit', params: { id: result.deposit }})
						} else {
							v.showHideDialogDeposit(false);
							v.alert = true;
							v.msgAlert = result.message;
						}
					})
					.finally(() => v.loadingForm = false );;
				}
				else {
					this.showHideDialogDeposit(false);
					this.alert = true;
					this.msgAlert = 'Ocorreu um problema com seu login, por favor recarregue a página.';
				}
			},
			getClientBalance: function() {
				if (this.cliente) {
					var config = {
						headers: {Authorization: 'Bearer  ' + this.$store.state.cliente.token}
					};

					axios
					.get(this.$root.$data.API_URL + 'client/balance', config)
					.then(response => {
						let result = response.data

						if (result.success) {
							this.updateClientBalance(result.balance)
						}
						else {
							this.alert = true
							this.msgAlert = result.message
						}
					});
				}
				else {
					this.alert = true;
					this.msgAlert = 'Ocorreu um problema com seu login, por favor recarregue a página.';
				}
			},
			liberarRoleta: function() {

				if (this.roletaBloqueada) return false;

				if (this.liberado) {
					this.roletaBloqueada = true;
					this.spin(this.playResult.drawn);
				}
				else {
					this.liberandoRoleta = true;

					var jsonPlay = {};
					jsonPlay.value = this.valorRodada;

					var form = new FormData();
					form.append("data", JSON.stringify(jsonPlay));

					var config = {
						headers: {'Content-Type': 'application/x-www-form-urlencoded', Authorization: 'Bearer  ' + this.$store.state.cliente.token}
					};

					var v = this;
					axios.post(this.$root.$data.API_URL + 'client/play', form, config)
					.then(function (response) {
				        let result = response.data
						// console.log(result);
						if (result.success) {
							v.playResult = result;
							v.liberado = true;
							v.updateClientBalance(result.pre_balance)

							Velocity($('.btn-balance'), "callout.tada",{
								easing: 'easeOutQuint',
								duration: 1000
							});
						}
						else {
							v.alert = true
							v.msgAlert = result.message
						}
					})
					.finally(() => v.liberandoRoleta = false );
				}
			},
			updateClientBalance: function(balance) {
				this.$store.state.cliente.balance = balance
			}
		},
		mounted() {
			if (this.cliente)
				this.getClientBalance();

			this.render();
		},
		computed: {
			cliente: function () {
				return this.$store.state.cliente
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import "~vue-material/dist/theme/engine"; // Import the theme engine

	@include md-register-theme("default", (
		primary: #000000, // The primary color of your brand
		accent: #CB1323 // The secondary color of your brand
		));

	@import "~vue-material/dist/theme/all"; // Apply the theme

</style>


// WEBPACK FOOTER //
// src/components/TitanRoulette.vue